<template>
  <div :class="[`proposal-card`, { isActive }, { templateCard }]">
    <div class="proposal-card__info">
      <div class="proposal-card__info-name">
        <r-text>{{ proposal.name }}</r-text>
      </div>
      <div class="proposal-card__info-sub" v-if="proposal.company">
        <r-text type="caption" style="margin: 4px 0 0;">
          {{ proposal.company }}
        </r-text>
      </div>
    </div>
    <div class="proposal-card__status">
      <div :class="[`proposal-card__status-wrap ${getStatus()}`]">
        <i :class="[`el-icon-${getStatus()}`]" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    proposal: {
      type: Object,
      required: true,
      default: () => null
    },
    templateCard: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isActive() {
      if (this.templateCard) return false;
      return this.proposal.id === this.$route.query.id;
    }
  },
  methods: {
    getStatus() {
      if (this.templateCard) return "warning";
      return this.proposal.accepted
        ? "success"
        : this.proposal.rejected
        ? "error"
        : "warning";
    }
  }
};
</script>

<style lang="scss" scoped>
.proposal-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
  border-radius: var(--border-radius);
  border: 1px solid;
  transition: border-color 0.12s ease;
  border-color: var(--dividers_low_contrast) !important;
  background-color: var(--field_bg) !important;
  cursor: pointer;
  &__info {
    width: calc(100% - 32px);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow: hidden;
    &-name,
    &-sub {
      overflow: hidden;
      width: 100%;
      text-align: start;
      > div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  &__status {
    width: 24px;
    &-wrap {
      &.success {
        color: var(--accent_success);
      }
      &.error {
        color: var(--accent_error);
      }
    }
  }
  &:hover {
    border-color: var(--accent_primary) !important;
  }
  &.isActive {
    border-color: var(--accent_primary) !important;
    background-color: var(--accent_primary) !important;
    cursor: default;
    .r-text.caption-2 {
      color: var(--white_white) !important;
    }
  }
  &.templateCard {
    cursor: default !important;
    opacity: 0.6;
    &:hover {
      border-color: var(--dividers_low_contrast) !important;
    }
  }
}
</style>
